var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4549 24.7904C11.1987 24.7904 11.8841 24.3674 12.2049 23.7112L14.2758 19.5695C14.4799 19.1612 14.582 18.7237 14.582 18.2716V11.6654C14.582 10.8633 13.9258 10.207 13.1237 10.207H7.29036C6.48828 10.207 5.83203 10.8633 5.83203 11.6654V17.4987C5.83203 18.3008 6.48828 18.957 7.29036 18.957H10.207L8.70495 21.9612C8.0487 23.2591 8.99661 24.7904 10.4549 24.7904ZM25.0383 24.7904C25.782 24.7904 26.4674 24.3674 26.7883 23.7112L28.8591 19.5695C29.0633 19.1612 29.1654 18.7237 29.1654 18.2716V11.6654C29.1654 10.8633 28.5091 10.207 27.707 10.207H21.8737C21.0716 10.207 20.4154 10.8633 20.4154 11.6654V17.4987C20.4154 18.3008 21.0716 18.957 21.8737 18.957H24.7904L23.2883 21.9612C22.632 23.2591 23.5799 24.7904 25.0383 24.7904Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.e2bce57d3ac37c8e11097409e5fd3af1.svg";
export { ForwardRef as ReactComponent };